import React from 'react';
import SimpleProviderDashboard from './SimpleProviderDashboard';

// Test component that bypasses authentication for testing calendar functionality
const ProviderDashboardTest = () => {
  // Simulate being logged in as a provider for testing
  React.useEffect(() => {
    const testSession = {
      session_token: 'test-provider-token',
      user: {
        id: 'demo-provider-001',
        name: 'Excellence Medical Center',
        email: 'admin@excellence.medical.com',
        role: 'provider',
        facility_type: 'healthcare_clinic'
      },
      expires_at: new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString()
    };
    
    localStorage.setItem('demo_session', JSON.stringify(testSession));
  }, []);

  return (
    <div>
      <div className="bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded mb-4">
        <strong>Test Mode:</strong> This is a test version of the provider dashboard for debugging calendar functionality.
      </div>
      <SimpleProviderDashboard />
    </div>
  );
};

export default ProviderDashboardTest;